const scriptId = process.env.REACT_APP_ONE_TRUST_KEY

const createScriptElement = (
  src: string,
  attributes: Record<string, string> = {}
) => {
  const script = document.createElement("script")
  script.type = "text/javascript"
  if (src.length > 0) {
    script.src = src
  }
  Object.entries(attributes).forEach(([key, value]) => {
    script.setAttribute(key, value)
  })
  document.head.appendChild(script)
}

const initOneTrust = () => {
  if (!scriptId) {
    return
  }

  createScriptElement(
    `https://cdn.cookielaw.org/consent/${scriptId}/OtAutoBlock.js`
  )
  createScriptElement(
    "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js",
    {
      "data-document-language": "true",
      charset: "UTF-8",
      "data-domain-script": scriptId
    }
  )
  createScriptElement("", {
    innerHTML: "function OptanonWrapper() { }"
  })
}

export default initOneTrust
